import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Loader from "./components/loader";
const PageLoaderWrapper = ({ children }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 1000); // adjust delay as needed

    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return loading ? <Loader /> : children;
};

export default PageLoaderWrapper;
